import { Route } from 'react-router';
import { getCompleteRegistrationPath } from '@/bundle/Auth/InviteUserFlow/CompleteRegistrationPage/path/path';
import { CompleteRegistrationPage } from '@/bundle/Auth/InviteUserFlow/CompleteRegistrationPage/CompleteRegistrationPage';
import { CreatePinCodePage } from '@/bundle/Auth/InviteUserFlow/CreatePinCodePage/CreatePinCodePage';
import { getCreatePinCodePath } from '@/bundle/Auth/InviteUserFlow/CreatePinCodePage/path/path';
import { AUTH_STEP } from '../const/const';
import { AuthProtectedRoute } from '@/bundle/Routes/AuthProtectedRoute';
import { getResetRequestFromEmailPath } from '../InviteUserFlow/ResetRequestFromEmailPage/path/path';
import { ResetRequestFromEmailPage } from '../InviteUserFlow/ResetRequestFromEmailPage/ResetRequestFromEmailPage';
import { getResetRequestAuthPath } from '../InviteUserFlow/ResetRequestAuthPage/path/path';
import { ResetRequestAuthPage } from '../InviteUserFlow/ResetRequestAuthPage/ResetRequestAuthPage';
import { SetInitialPasswordValidateTotpPage } from '../InviteUserFlow/SetInitialPasswordValidateTotpPage/SetInitialPasswordValidateTotpPage';
import { getSetInitialPasswordPath } from '@/bundle/Auth/InviteUserFlow/SetInitialPasswordPage/path/path';
import { SetInitialPasswordPage } from '@/bundle/Auth/InviteUserFlow/SetInitialPasswordPage/SetInitialPasswordPage';
import { getSetInitialPasswordValidateTotpPath } from '../InviteUserFlow/SetInitialPasswordValidateTotpPage/path/path';
import { getEmailConfirmationValidateTotpPath } from '../InviteUserFlow/EmailConfirmationValidateTotpPage/path/path';
import { EmailConfirmationValidateTotpPage } from '../InviteUserFlow/EmailConfirmationValidateTotpPage/EmailConfirmationValidateTotpPage';
import { getEmailConfirmationLinkExpiredPath } from '../pages/EmailConfirmationExpiredPage/path';
import { EmailConfirmationExpiredPage } from '../pages/EmailConfirmationExpiredPage/EmailConfirmationExpiredPage';

export const INVITE_USER_FLOW_ROUTES = [
  <Route
    key={getSetInitialPasswordValidateTotpPath()}
    path={getSetInitialPasswordValidateTotpPath()}
    element={<SetInitialPasswordValidateTotpPage />}
  />,
  <Route key={getSetInitialPasswordPath()} path={getSetInitialPasswordPath()} element={<SetInitialPasswordPage />} />,

  <Route
    key={getEmailConfirmationValidateTotpPath()}
    path={getEmailConfirmationValidateTotpPath()}
    element={<EmailConfirmationValidateTotpPage />}
  />,
  <Route
    key={getEmailConfirmationLinkExpiredPath()}
    path={getEmailConfirmationLinkExpiredPath()}
    element={<EmailConfirmationExpiredPage />}
  />,
  <Route
    key={getResetRequestFromEmailPath()}
    path={getResetRequestFromEmailPath()}
    element={<ResetRequestFromEmailPage />}
  />,
  <Route
    key={getResetRequestAuthPath()}
    path={getResetRequestAuthPath()}
    element={
      <AuthProtectedRoute allowedStep={AUTH_STEP.PIN_AUTHENTICATION}>
        <ResetRequestAuthPage />
      </AuthProtectedRoute>
    }
  />,
  <Route
    key={getCompleteRegistrationPath()}
    path={getCompleteRegistrationPath()}
    element={
      <AuthProtectedRoute allowedStep={AUTH_STEP.COMPLETE_REGISTRATION}>
        <CompleteRegistrationPage />
      </AuthProtectedRoute>
    }
  />,
  <Route
    key={getCreatePinCodePath()}
    path={getCreatePinCodePath()}
    element={
      <AuthProtectedRoute allowedStep={AUTH_STEP.SET_PIN}>
        <CreatePinCodePage />
      </AuthProtectedRoute>
    }
  />,
];
